import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Flex
} from "@sainsburys-tech/fable";
import { formatZoneListSceneValue } from "../../model/store-commissioning/formatSceneLevelValues";
import * as zoneTypeKeys from "../../model/lighting-zone-types/zoneTypeKeys.js";
import { Event } from "../Tracking";

import { Edit, Delete, AlertCircleFilled } from '@sainsburys-tech/icons'

const StoreZoneListItem = props => {
  const isReadOnlyZone =
    props.zoneConfiguration.zone.zoneType === zoneTypeKeys.IO;

  return (
    <Box className="fable:border fable:px-8 fable:pb-8 fable:pt-4">
      <Flex gap="md" alignItems="flex-start">
        <div style={{ flex: 1 }}>
          <h3 className="cb-u-word-wrap fable:pt-4">
            {props.zoneConfiguration.zone.name}
          </h3>
        </div>
        <div style={{ flexShrink: 0, display: 'flex', gap: '8px' }}>
          <Button
            variant="ghost"
            size="sm"
            title="Edit"
            onClick={() =>
              props.editStoreZone(
                props.zoneConfiguration.zone.zoneId,
                props.zoneConfiguration.zone.name,
                Event(
                  "Store Zone Configuration Event",
                  "Edit Zone Configuration",
                  "(not set)"
                )
              )
            }
          >
             <Edit fixed />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            title="Delete"
            onClick={e =>
              props.deleteStoreZone(
                e,
                props.storeId,
                props.zoneConfiguration.zone.zoneId,
                props.zoneConfiguration.zone.name
              )
            }
          >
            <Delete fixed />
          </Button>
        </div>
      </Flex>
      <span className="fable:px-4 fable:py-2 fable:bg-gray-100">Scenes</span>
      {props.zoneConfiguration.scenes.find(
        scene => scene.sceneLevel === undefined || scene.sceneLevel === null
      ) && (
        <div className="fable:mt-0">
          <AlertCircleFilled className="cb-c-store-zone-list-item__error-img  -fable:mr-6" />
          <b>Lighting levels not yet set</b>
        </div>
      )}
      {props.zoneConfiguration.scenes.map((scene, index) => (
        <Flex key={index} gap="md" alignItems="center" className="fable:mt-2">
          <div style={{ flex: 1 }}>
            <span>{scene.scene.description}</span>
          </div>
          <div style={{ flexShrink: 0 }}>
            <span className="fable:text-4xl">
              {formatZoneListSceneValue(
                props.zoneConfiguration.zone.zoneType,
                scene.sceneLevel
              )}
            </span>
          </div>
        </Flex>
      ))}
      {!isReadOnlyZone && (
        <Link
          to={{
            pathname:
              "/lighting/stores/" +
              props.storeId +
              "/zones/" +
              props.zoneConfiguration.zone.zoneId +
              "/scene-levels"
          }}
        >
          <Button
            className="fable:mt-8"
            style={{ width: '100%' }}
            onClick={() =>
              Event("Scene Level Event", "Set scene values", "(not set)")
            }
          >
            Set scene values
          </Button>
        </Link>
      )}
    </Box>
  );
};

StoreZoneListItem.propTypes = {
  zoneConfiguration: PropTypes.shape({
    zone: PropTypes.shape({
      zoneId: PropTypes.string,
      name: PropTypes.string
    }),
    scenes: PropTypes.arrayOf(
      PropTypes.shape({
        scene: PropTypes.shape({
          name: PropTypes.string,
          description: PropTypes.string
        }),
        sceneLevel: PropTypes.string
      })
    )
  }),
  storeId: PropTypes.string,
  zoneId: PropTypes.string
};

export default StoreZoneListItem;
